"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrate = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Widgets = __importStar(require("Public/Widgets/index"));
var Badges = __importStar(require("Public/Badges/index"));
var hydrate = function (root, selector, _a) {
    var e_1, _b;
    var _c = _a === void 0 ? {} : _a, di = _c.di, $scope = _c.$scope;
    var hosts = Array.from($(selector, root));
    var _loop_1 = function (host) {
        try {
            var _d = __read([
                "data-hydration-component",
                "data-hydration-host-id",
                "data-hydration-data",
            ].map(function (attr) {
                var value = host.getAttribute(attr);
                if (!value) {
                    throw new Error("Required attribute \"".concat(attr, "\" was not found on ").concat(host, "."));
                }
                return value;
            }), 3), componentName_1 = _d[0], hostId = _d[1], props = _d[2];
            var component = Object.values(__assign(__assign({}, Widgets), Badges)).find(function (component) { return component.hydrationComponentName === componentName_1; });
            if (!component) {
                throw new Error("Component \"".concat(componentName_1, "\" could not be found in the widgets / badges list for rehydration."));
            }
            react_dom_1.default.hydrate(react_1.default.createElement(component, __assign(__assign({}, JSON.parse(props)), { hostId: hostId, di: di, $scope: $scope })), host);
        }
        catch (err) {
            console.error("Unable to hydrate component");
            console.error(err);
        }
    };
    try {
        for (var hosts_1 = __values(hosts), hosts_1_1 = hosts_1.next(); !hosts_1_1.done; hosts_1_1 = hosts_1.next()) {
            var host = hosts_1_1.value;
            _loop_1(host);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (hosts_1_1 && !hosts_1_1.done && (_b = hosts_1.return)) _b.call(hosts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return function () {
        var e_2, _a;
        try {
            for (var hosts_2 = __values(hosts), hosts_2_1 = hosts_2.next(); !hosts_2_1.done; hosts_2_1 = hosts_2.next()) {
                var host = hosts_2_1.value;
                react_dom_1.default.unmountComponentAtNode(host);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (hosts_2_1 && !hosts_2_1.done && (_a = hosts_2.return)) _a.call(hosts_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
};
exports.hydrate = hydrate;
